var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("router-module"),
      _c("section", { staticClass: "pa pa--t_md pa--b_md" }, [
        _c(
          "div",
          { staticClass: "ug-container ug-container--variant_large" },
          [
            _c(
              "text-bemto",
              {
                staticClass: "ma ma--b_xs",
                attrs: {
                  fw: "bold",
                  lh: "initial",
                  fs: "xl",
                  color: "black",
                  tag: "p"
                }
              },
              [_vm._v("PROFILE")]
            ),
            _c(
              "div",
              { staticClass: "bg bg--white pa pa--f_1sm pa--f_md-md" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "ug-row ug-row--apearance_spaced ug-row--space_md"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "ug-cell ug-cols ug-cols--12 ug-cols--10-lg ug-cols--8-xl ug-cols--7-mac"
                      },
                      [_c("common-change")],
                      1
                    )
                  ]
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "bg bg--white pa pa--r_1sm pa--r_md-md pa--b_1sm pa--b_md-md pa--l_1sm pa--l_md-md"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "ug-row ug-row--apearance_spaced ug-row--space_md"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "ug-cell ug-cols ug-cols--12 ug-cols--10-lg ug-cols--8-xl ug-cols--7-mac"
                      },
                      [_c("email-panel")],
                      1
                    )
                  ]
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "bg bg--white pa pa--r_1sm pa--r_md-md pa--b_1sm pa--b_md-md pa--l_1sm pa--l_md-md"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "ug-row ug-row--apearance_spaced ug-row--space_md"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "ug-cell ug-cols ug-cols--12 ug-cols--10-lg ug-cols--8-xl ug-cols--7-mac"
                      },
                      [_c("password-panel")],
                      1
                    )
                  ]
                )
              ]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fec32d7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fec32d7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Pages/Cabinet/SettingsCabinet.vue
// module id = 855
// module chunks = 0